import Testimonials from "@/components/feature/Testimonials";

export default function TestimonialsPage() {
  return <Testimonials />;
}